import { Box, Button, Drawer } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { EducationIcon, LogoutIcon } from '../../../assets/icons';
import { ProfileNavigation } from '../../../pages/profile/layout/ProfileNavigation';
import { openQualificationDrawer, showBackButton } from '../../../store/features/qualification/qualificationSlice';
import { useAppDispatch } from '../../../store/hooks';
import { AppIcon } from '../../app-icon/AppIcon';
import { accountMenuStyles } from './styles';

interface TabletProfileMenuProps {
  signOut: () => void;
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
}
export const TabletProfileMenu: React.FC<TabletProfileMenuProps> = ({ signOut, isDrawerOpen, onCloseDrawer }) => {
  const dispatch = useAppDispatch();
  const onManageQualificationBtnClick = (): void => {
    dispatch(showBackButton());
    onCloseDrawer();
    dispatch(openQualificationDrawer());
  };
  const location = useLocation();
  useEffect(() => {
    onCloseDrawer();
  }, [location, onCloseDrawer]);

  return (
    <Drawer anchor="right" open={isDrawerOpen} onClose={onCloseDrawer}>
      <ProfileNavigation>
        <Box sx={accountMenuStyles.tabletSignOutBtnWrapper}>
          <Button
            onClick={onManageQualificationBtnClick}
            sx={[accountMenuStyles.tabletSignOutBtn, { mb: 2 }]}
            startIcon={<AppIcon Icon={EducationIcon} />}
          >
            Manage Qualification
          </Button>
          <Button onClick={signOut} sx={accountMenuStyles.tabletSignOutBtn} startIcon={<AppIcon Icon={LogoutIcon} />}>
            Sign Out
          </Button>
        </Box>
      </ProfileNavigation>
    </Drawer>
  );
};
